<template>
  <div class="mobile">
    <div class="appBox">
      <div
        class="appItem"
        v-for="item in list"
        :key="item.name"
        @click="jump(item)"
      >
        <div class="leftBox">
          <ImgDecypt
            :imgCdn="imgCdn"
            class="appIcon"
            :src="item.iconImg"
            :key="item.iconImg"
            v-if="item.iconImg"
          />
          <div class="appInfo">
            <div class="appName">{{ item.name }}</div>
            <div class="appDesc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="downloadBtn">下载</div>
        <div class="horizontalLine"></div>
      </div>
      <NoData v-if="!(list && list.length)" />
    </div>
    <div class="sizeBox"></div>
    <div class="bottomBox">
      <div class="tgBox" @click="jumpUrl('https://t.me/yuyeyingzi')">
        客服TG @yuyeyingzi
      </div>
    </div>
  </div>
</template>
<script>
import { mixins } from "./../../../mixin/index";
import ImgDecypt from "@/components/ImgDecypt";
import NoData from "@/components/NoData";

export default {
  name: "mobile",
  components: {
    ImgDecypt,
    NoData,
  },
  mixins: [mixins],
};
</script>
<style lang="scss" scoped>
.mobile {
  height: 100%;
  overflow-y: auto;
  .appBox {
    padding: 0 20px;
    .appItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      position: relative;
      .leftBox {
        display: flex;
        align-items: center;
        .appIcon {
          height: 62px;
          width: 62px;
        }
        .appInfo {
          margin-left: 12px;
          .appName {
            color: rgba(0, 0, 0, 0.9);
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
          }
          .appDesc {
            color: rgba(0, 0, 0, 0.3);
            font-size: 12px;
            line-height: 20px;
            margin-top: 6px;
          }
        }
      }
      .downloadBtn {
        height: 28px;
        width: 72px;
        color: #4d6bfe;
        text-align: center;
        font-size: 14px;
        line-height: 28px;
        border-radius: 28px;
        background: rgba(0, 0, 0, 0.05);
      }
      .horizontalLine {
        position: absolute;
        width: 261px;
        height: 1px;
        background: rgb(235, 235, 235);
        bottom: 0;
        right: 0;
      }
    }
  }
  .sizeBox {
    height: 100px;
  }
  .bottomBox {
    height: 80px;
    position: fixed;
    left: 0px;
    bottom: 0px;
    background: rgb(247, 247, 247);
    width: 100%;
    .tgBox {
      height: 44px;
      width: 355px;
      border-radius: 6px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 44px;
      background: #4d6bfe;
      margin: 12px auto 0;
    }
  }
}
</style>
